import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import MainHero from '../components/MainHero';
import AudienceStrip from '../components/AudienceStrip';
import HomeStats from '../components/HomeStats';
import ServicesSection from '../components/ServicesSection';
import SocialImpactSection from '../components/SocialImpactSection';
import ResearchSection from '../components/ResearchSection';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <MainHero />
      <AudienceStrip />
      <HomeStats />
      <HeroSection />
      <ServicesSection />
      <SocialImpactSection />
      <ResearchSection />
    </div>
  );
};

export default Home;
